import { useState } from 'react'
import { ArrowUpRight, Globe, Search } from 'lucide-react'
import { openExternal, haptic } from '../telegram'

const QUICK_LINKS: { label: string; url: string }[] = [
  { label: 'Google', url: 'https://www.google.com' },
  { label: 'YouTube', url: 'https://www.youtube.com' },
  { label: 'Wikipedia', url: 'https://ru.wikipedia.org' },
  { label: 'Telegram Web', url: 'https://web.telegram.org' }
]

function normalizeUrl(raw: string): string {
  const trimmed = raw.trim()
  if (!trimmed) return ''
  if (/^https?:\/\//i.test(trimmed)) return trimmed
  return `https://${trimmed}`
}

export function BrowserView() {
  const [input, setInput] = useState('')

  const go = (url: string) => {
    const target = normalizeUrl(url)
    if (!target) return
    haptic('medium')
    openExternal(target)
  }

  return (
    <div className="flex h-full flex-col overflow-y-auto px-4 py-4">
      <div className="rounded-xl border border-border-primary bg-bg-secondary p-3">
        <div className="text-[11px] uppercase tracking-wider text-text-muted">
          Встроенный браузер недоступен в Mini App
        </div>
        <p className="mt-1 text-[13px] leading-relaxed text-text-secondary">
          Telegram Web App не позволяет открывать произвольные сайты внутри себя.
          Ссылки открываются во внешнем браузере — как в настольном ORBIT, но без webview.
        </p>
      </div>

      <div className="mt-4 flex gap-2">
        <div className="relative flex-1">
          <Search
            size={17}
            className="pointer-events-none absolute left-3 top-1/2 -translate-y-1/2 text-text-muted"
          />
          <input
            value={input}
            onChange={e => setInput(e.target.value)}
            onKeyDown={e => {
              if (e.key === 'Enter') go(input)
            }}
            placeholder="Введите адрес или запрос…"
            className="w-full rounded-xl border border-border-primary bg-bg-tertiary py-2.5 pl-10 pr-3 text-[15px] text-text-primary placeholder:text-text-muted focus:border-transparent focus:outline-none focus:ring-2 focus:ring-accent-primary"
          />
        </div>
        <button
          onClick={() => go(input)}
          disabled={!input.trim()}
          className="flex h-[44px] w-[44px] shrink-0 items-center justify-center rounded-xl bg-accent-primary text-bg-primary disabled:opacity-40"
          aria-label="Открыть"
        >
          <ArrowUpRight size={20} />
        </button>
      </div>

      <div className="mt-5">
        <div className="mb-2 text-[11px] uppercase tracking-wider text-text-muted">Быстрый доступ</div>
        <div className="grid grid-cols-2 gap-2">
          {QUICK_LINKS.map(l => (
            <button
              key={l.url}
              onClick={() => go(l.url)}
              className="flex items-center gap-2 rounded-xl border border-border-primary bg-bg-card px-3.5 py-3 text-left text-[14px] text-text-primary transition-colors active:scale-[0.98] active:border-accent-primary/50"
            >
              <Globe size={16} className="shrink-0 text-accent-primary" />
              <span className="truncate">{l.label}</span>
            </button>
          ))}
        </div>
      </div>
    </div>
  )
}
